import React from "react";
import WidgetReference from './WidgetReference';

export default function GettingStarted() {
  return (
    <>
      <WidgetReference guideId="getting-started" />
    <iframe
      src="https://scribehow.com/embed/Creating_a_Sweepstakes_on_Shopify__cYk2mtlETGevFwDK992Heg?skipIntro=true&removeLogo=true&as=scrollable"
      height="640"
      title="Getting Started"
      allowFullScreen
    />
    </>
  );
}
